<script>
  import { APPS } from '../../os/apps.js';
  import { launchApp } from '../../os/windows.svelte.js';
  import { portfolio } from '../../os/portfolio.svelte.js';
  import { session } from '../../os/session.svelte.js';

  let search = $state('');

  const isAvailable = (app) => app && (!app.adminOnly || session.role === 'admin');

  const filtered = $derived(
    APPS.filter(a => isAvailable(a) && a.label.toLowerCase().includes(search.toLowerCase()))
  );
</script>

<div class="mobile-launcher">
  <header class="ml-topbar">
    <h1>{portfolio.profile.name}</h1>
    <input class="ml-search" type="search" placeholder="Search apps…" bind:value={search} aria-label="Search apps" />
  </header>

  <div class="ml-grid">
    {#each filtered as app}
      <button class="ml-app" onclick={() => { search = ''; launchApp(app); }}>
        <span class="ml-app-icon">{app.label[0]?.toUpperCase() ?? '?'}</span>
        <span class="ml-app-label">{app.label}</span>
      </button>
    {/each}
  </div>

  {#if !filtered.length}
    <p class="ml-empty">No apps match "{search}"</p>
  {/if}
</div>

<style>
  .mobile-launcher {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #1b1e1f;
    color: #e6e8e9;
    overflow: hidden;
  }
  .ml-topbar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #25292a;
    border-bottom: 1px solid #0d0f10;
    flex-shrink: 0;
  }
  .ml-topbar h1 {
    margin: 0;
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ml-search {
    flex: 1;
    min-width: 0;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #3b4142;
    background: #111415;
    color: #eee;
    font-size: 14px;
    outline: none;
  }
  .ml-search:focus {
    border-color: #4d91c9;
  }
  .ml-grid {
    flex: 1;
    overflow-y: auto;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
    gap: 12px;
    padding: 16px;
    align-content: start;
  }
  .ml-app {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    padding: 10px 4px;
    background: transparent;
    border: none;
    border-radius: 8px;
    color: #c9cdce;
    cursor: pointer;
    transition: background 0.15s;
    touch-action: manipulation;
  }
  .ml-app:active {
    background: rgba(255,255,255,0.1);
  }
  .ml-app-icon {
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #356e9f, #1d4b73);
    border-radius: 14px;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  }
  .ml-app-label {
    font-size: 10px;
    text-align: center;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 68px;
  }
  .ml-empty {
    text-align: center;
    color: #889091;
    font-size: 13px;
    padding: 40px 16px;
    margin: 0;
  }
</style>
